import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map, tap } from 'rxjs';
import { Session } from '../../providers/session/session.service';
import { AuthActions } from './auth.actions';
import { AuthService } from './auth.service';

/**
 * @description Auth Effects.
 * @exports
 * @class AuthEffects
 */
@Injectable()
export class AuthEffects {
  private readonly actions = inject(Actions);
  private readonly service = inject(AuthService);
  private readonly session = inject(Session);

  readonly onAuthFetchProfile_SwitchProfile = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.fetchProfile, AuthActions.switchProfile),
        concatMap(() => this.service.profile()),
        map((profile) => AuthActions.setProfile({ profile }))
      );
    },
    { dispatch: true }
  );

  readonly onAuthLogout = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.logout),
        tap(() => {
          this.session.clear();
          this.session.clear('auth-type');
          this.session.clearWithPrefixOrHasKey('lwb-healthscore');
        })
      );
    },
    { dispatch: false }
  );

  readonly onAuthSetProfile = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.setProfile),
        tap(({ profile }) => {
          this.session.store(this.session.keys.profile, profile);
        })
      );
    },
    { dispatch: false }
  );
}
